import styled from "styled-components/macro";

export const Container = styled.div`
  /* padding: 15px 25px; */
  /* padding-left: 25px; */
  justify-content: space-between;
  text-align: left;
  background: white;
  user-select: auto;
  display: flex;
  background: var(--menu-color);
  color: var(--grey-0);

  .templates {
    width: 230px;
    padding: 15px 0;

    h2 {
      padding: 5px 20px;
      font-size: 22px;
    }

    ul {
      margin-top: 1rem;

      li {
        padding: 8px 20px;
        cursor: pointer;

        &.active {
          background: var(--menu-color-hover);
          font-weight: 600;
        }
      }
    }
  }

  .template {
    border-left: 2px solid var(--menu-color-active);
    flex-grow: 1;
    width: calc(100% - 230px);
    padding: 25px;

    h3 {
      margin-bottom: 0.5rem;
    }

    p {
      margin: 1rem auto;
      line-height: 1.2rem;

      a {
        text-decoration: underline;
        white-space: nowrap;
      }
    }

    .examples p {
      font-size: 14px;
    }
  }

  button,
  input[type="submit"] {
    font-size: 16px;
    background: var(--primary-cta);

    &:hover {
      background: var(--primary-cta-hover);
    }

    &:disabled {
      // background: var(--grey-2) !important;
      background: none;
      cursor: default;
    }

    color: white;
    border: 0;
    border-radius: 25px;
    font-family: Inter;
    font-weight: 500;
    padding: 10px 40px;
    cursor: pointer;
    margin-top: 15px;
  }
`;
